/* ROVA HAIR - Mobile swipe gallery for BKY - Main Product
 * Bien khoi anh lon (.blocky-featured-product__main) thanh slider cuon ngang that su
 * tren mobile (<=749px). Desktop giu nguyen 100%.
 *
 * LUU Y SPECIFICITY: CSS goc cua section dung selector co ID
 * (#blocky-featured-product-<id> .blocky-featured-product__media { display: none })
 * = do uu tien 110, luon thang selector chi co class (10) du dat sau.
 * Vi vay cac thuoc tinh ghi de BAT BUOC phai co !important.
 */
(function () {
  var MQ = '(max-width: 749px)';
  var CSS = [
    '.rova-counter{display:none}',
    '@media screen and (max-width:749px){',
    '.blocky-featured-product__media-wrap{position:relative}',
    '.blocky-featured-product__main{display:flex!important;grid-template-areas:none!important;',
    'overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory;',
    '-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;',
    'scrollbar-width:none;-ms-overflow-style:none}',
    '.blocky-featured-product__main::-webkit-scrollbar{display:none!important}',
    '.blocky-featured-product__main .blocky-featured-product__media,',
    '.blocky-featured-product__main .blocky-featured-product__media.is-active{display:block!important;',
    'flex:0 0 100%!important;width:100%!important;max-width:100%!important;height:100%!important;',
    'grid-area:auto!important;scroll-snap-align:center;scroll-snap-stop:always}',
    '.rova-counter{display:block;position:absolute;right:10px;bottom:10px;z-index:3;padding:5px 9px;',
    'border-radius:999px;background:rgba(0,0,0,.55);color:#fff;font-size:12px;line-height:1;pointer-events:none}',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('rova-swipe-css')) return;
    var style = document.createElement('style');
    style.id = 'rova-swipe-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  function isMobile() { return window.matchMedia(MQ).matches; }

  function setup(root) {
    var stage = root.querySelector('.blocky-featured-product__main');
    if (!stage || stage.dataset.rovaSlider) return;

    var items = Array.prototype.slice.call(stage.querySelectorAll('[data-blocky-product-media]'));
    if (items.length < 2) return;
    stage.dataset.rovaSlider = '1';

    var wrap = stage.parentElement;
    var counter = wrap.querySelector('.rova-counter');
    if (!counter) {
      counter = document.createElement('div');
      counter.className = 'rova-counter';
      wrap.appendChild(counter);
    }

    var lock = false;
    var lockTimer = null;
    var scrollTimer = null;
    var resizeTimer = null;

    function activeIndex() {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function setCounter(i) { counter.textContent = (i + 1) + '/' + items.length; }

    function scrollToIndex(i, smooth) {
      if (!isMobile()) return;
      lock = true;
      clearTimeout(lockTimer);
      var left = stage.clientWidth * i;
      try {
        stage.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      } catch (e) {
        stage.scrollLeft = left;
      }
      lockTimer = setTimeout(function () { lock = false; }, 450);
    }

    stage.addEventListener('scroll', function () {
      if (!isMobile() || lock) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = stage.clientWidth || 1;
        var i = Math.round(stage.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > items.length - 1) i = items.length - 1;
        setCounter(i);
        if (items[i].classList.contains('is-active')) return;
        lock = true;
        if (typeof root.activateMedia === 'function') {
          root.activateMedia(items[i].getAttribute('data-blocky-product-media'));
        }
        clearTimeout(lockTimer);
        lockTimer = setTimeout(function () { lock = false; }, 60);
      }, 90);
    }, { passive: true });

    var observer = new MutationObserver(function () {
      if (lock) return;
      var i = activeIndex();
      setCounter(i);
      if (!isMobile()) return;
      var w = stage.clientWidth || 1;
      if (Math.round(stage.scrollLeft / w) === i) return;
      scrollToIndex(i, true);
    });
    items.forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { scrollToIndex(activeIndex(), false); }, 150);
    });

    setCounter(activeIndex());
    scrollToIndex(activeIndex(), false);
    console.log('[ROVA] swipe gallery ready -', items.length, 'anh, mobile =', isMobile());
  }

  function init() {
    injectCss();
    var roots = document.querySelectorAll('blocky-featured-product');
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 600);
  setTimeout(init, 1500);
})();